import purchaseOrderTypeService from "../../../../services/procurementService/purchaseOrderTypeService";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { CACHE_KEY_PURCHASEORDERTYPES } from "../../../../utils/constants";
import { PurchaseOrderTypeInterface } from "../../../../models/ProcurementModule/PurchateOrder/PurchaseOrderType";

interface UpdatePurchaseOrderTypeContext {
  previousPurchaseOrderTypes: PurchaseOrderTypeInterface[];
}

const useUpdatePurchaseOrderType = (page: number, pageSize: number) => {
  const queryClient = useQueryClient();

  return useMutation<
    PurchaseOrderTypeInterface,
    Error,
    PurchaseOrderTypeInterface,
    UpdatePurchaseOrderTypeContext
  >({
    mutationFn: async (purchaseOderType: PurchaseOrderTypeInterface) => {
      // Assuming the ID is stored in the purchaseOderType object or can be derived
      const { id, ...purchaseOrderTypeData } = purchaseOderType;
      return purchaseOrderTypeService.Update(id || "", purchaseOrderTypeData);
    },

    onMutate: async (updatedPurchaseOrderType: PurchaseOrderTypeInterface) => {
      await queryClient.cancelQueries({
        queryKey: [CACHE_KEY_PURCHASEORDERTYPES, page, pageSize],
      });

      const previousPurchaseOrderTypes =
        queryClient.getQueryData<PurchaseOrderTypeInterface[]>([
          CACHE_KEY_PURCHASEORDERTYPES,
          page,
          pageSize,
        ]) || [];

      queryClient.setQueryData<PurchaseOrderTypeInterface[]>(
        [CACHE_KEY_PURCHASEORDERTYPES, page, pageSize],
        (purchaseOrderTypes = []) =>
          purchaseOrderTypes.map((purchaseOderType) =>
            purchaseOderType.id === updatedPurchaseOrderType.id
              ? updatedPurchaseOrderType
              : purchaseOderType
          )
      );

      return { previousPurchaseOrderTypes };
    },

    onSuccess: (savedPurchaseOrderType) => {
      queryClient.setQueryData<PurchaseOrderTypeInterface[]>(
        [CACHE_KEY_PURCHASEORDERTYPES, page, pageSize],
        (purchaseOrderTypes) =>
          purchaseOrderTypes?.map((purchaseOrderType) =>
            purchaseOrderType.id === savedPurchaseOrderType.id
              ? savedPurchaseOrderType
              : purchaseOrderType
          )
      );
    },

    onError: (error, updatedPurchaseOrderType, context) => {
      if (!context) return;

      queryClient.setQueryData<PurchaseOrderTypeInterface[]>(
        [CACHE_KEY_PURCHASEORDERTYPES, page, pageSize],
        context.previousPurchaseOrderTypes
      );
    },
  });
};

export default useUpdatePurchaseOrderType;
